import { Stack } from '@mantine/core';

export const StackConfig = Stack.extend({
  defaultProps: {
    gap: 0,
  },
});
